// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__Ns8_W","emptyList":"List_emptyList__tzgjp","collectionList":"List_collectionList__2UWoH","collectionListHeader":"List_collectionListHeader__3mkML"};